// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"ri-z","carouselContainer":"si-z","carouselContent":"ti-z"};